// Put your application javascript here
let app = {
  body: document.getElementsByTagName("body")[0],
  main: document.getElementsByTagName("main")[0],
  header: document.getElementsByTagName("header")[0],
  closeBagButton: document.getElementById("close-bag"),
  bagShowStatus: false,
  overlay: null,

  init: () => {
    app.headerShoppingcartWatcher();
    app.siteNavigationWatcher();

    document.addEventListener("scroll", () => {
      let scrolled = window.scrollY;

      if (scrolled) {
        app.header.classList.add("scroll");
      } else {
        app.header.classList.remove("scroll");
      }
    });
  },

  siteNavigationWatcher: () => {
    const siteHeader = document.querySelector("body > header");
    const navOpen = document.getElementById("site-navigation-open");
    const navClose = document.getElementById("site-navigation-close");
    const siteNav = document.getElementById("site-navigation");
    const parentMenuElements = document.querySelectorAll(
      "header nav > ul > li > a"
    );

    /**
     * Mobile nav open button click
     */
    navOpen.addEventListener("click", () => {
      siteNav.classList.add("active");
    });

    /**
     * Mobile nav close button click
     */
    navClose.addEventListener("click", () => {
      siteNav.classList.remove("active");
      siteHeader.classList.remove("active");
    });

    /**
     * Handle click on parent menu elements
     */
    [...parentMenuElements].forEach((el) => {
      el.addEventListener("click", (ev) => {
        if (el.parentNode.classList.contains("has-children")) {
          ev.preventDefault();
        }

        if (!el.parentNode.classList.contains("active")) {
          deactivateSubElements();
          siteHeader.classList.add("active");
          el.parentElement.classList.add("active");
        } else {
          siteHeader.classList.remove("active");
          deactivateSubElements();
        }
      });
    });

    /**
     * Handle click outside nav
     */
    document.addEventListener("click", (event) => {
      const isClickInside = siteHeader.contains(event.target);

      if (!isClickInside) {
        deactivateNavigation();
      }
    });

    function deactivateNavigation() {
      siteHeader.classList.remove("active");
      deactivateSubElements();
    }

    function deactivateSubElements() {
      [...parentMenuElements].forEach((el) => {
        el.parentNode.classList.remove("active");
      });
    }
  },

  initOverlay: (el) => {
    // Check if it is created first
    if (app.overlay == null) {
      app.overlay = document.createElement("div");
    }

    // Set styles
    app.overlay.classList.add(
      "fixed",
      "left-0",
      "right-0",
      "top-0",
      "bottom-0",
      "bg-black",
      "opacity-70",
      "z-10"
    );

    // Append to body
    el.append(app.overlay);

    // Set click handler
    app.overlay.addEventListener("click", () => {
      app.overlay.remove();
      app.overlay = null;
    });
  },

  headerShoppingcartWatcher: () => {
    let body = document.getElementsByTagName("body")[0];
    let openButton = document.getElementById("shoppingcart-button");
    let container = document.getElementById("shoppingcart-container");
    let main = document.getElementById("main");

    openButton.addEventListener("click", (e) => {
      e.preventDefault();
      app.bagShowStatus = !app.bagShowStatus;
      if (app.bagShowStatus) {
        body.classList.add("modal-open");
      } else {
        body.classList.remove("modal-open");
      }
      container.classList.toggle("translate-x-full");
    });

    main.addEventListener("click", (e) => {
      container.classList.add("translate-x-full");
      body.classList.remove("modal-open");
      app.bagShowStatus = false;
    });

    app.closeBagButton.addEventListener("click", (e) => {
      e.preventDefault();
      app.bagShowStatus = false;
      body.classList.remove("modal-open");
      container.classList.toggle("translate-x-full");
    });
  },
};

(function () {
  "use strict";

  app.init();
})();
